import styled, { css } from 'styled-components';
import { colors } from 'globalStyles';
import { media } from 'utils/style-utils'


export const TableWrapper = styled.div`
  text-align: center;
  margin-top: 18px;
  overflow-y: auto;
  ${({ isLeadsTable }) =>
    !isLeadsTable
      ? media.mobile_plus`
      overflow-y: initial;
  `
      : media.desktop_plus`
  overflow-y: initial;
  `}
`;

export const StyledTable = styled.table`
  empty-cells: show;
  background-color: ${colors.WHITE};
  text-align: left;
`;

export const TableHead = styled.thead`
  > tr {
    height: 30px;
    text-align: left;

    th {
      color: ${colors.DARK};
      font-size: 8px;
      font-weight: 900;
      letter-spacing: 2px;
      line-height: 14px;
      text-transform: uppercase;
    }
  }
`;

export const TableBody = styled.tbody`
  > tr {
    border-bottom: 1px solid #E7EBEC;
    font-size: 14px;
    font-weight: normal;
    line-height: 18px;
    height: 48px;
    color:  ${colors.BODY};

    &:hover {
      background-color: rgb(240, 255, 253);
    }
  }

  .loader {
    text-align: center;
    td {
      > div {
        margin: 10px 0;
      }
    }
  }
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #E7EBEC;

  + tr {
    border-top: solid 1px #E7EBEC;
  }
`;

const tableCellStyles = css`
  width: 288px;
  margin-right: 0px;
  ${({ isNumber }) => isNumber && `
    width: 60px;
  `}

  &:first-child {
    width: 204px;
    margin-right: 20px;
    padding-left: 20px;
  }

  &:nth-child(2) {
    ${media.desktop`
      width: 204px;
    `}

    ${media.tablet`
      width: 204px;
    `}

    ${media.mobile`
      width: 195px;
    `}
  }

  &:nth-child(3) {
    ${media.desktop`
      width: 156px;
    `}
    ${media.tablet`
      width: 217px;
    `}
  }

  &:last-child {
    width: 57px;
    text-align: center;
        ${media.desktop`
        width: 57px;
        padding-right: 0px;
      `}

      ${media.tablet`
        width: 57px;
        padding-right: 0px;
      `}
      ${media.mobile`
        width: 57px;
        padding-right: 0px;
      `}
  }
`;

export const TableHeader = styled.th`
  ${tableCellStyles}
  > div {
    width: 100%;
    display: inline;
    &:hover {
      color: ${colors.MAIN_COLOR};
      cursor: pointer;
    }
    &.sorted {
      color: ${colors.MAIN_COLOR};
      svg {
        margin: 0px 0px -2px 2px;
        > g {
          fill: ${colors.MAIN_COLOR};
        }
      }
    }
  }
  
  .sort-desc-icon {
    transform: rotate(180deg);
  }
`;

export const TableData = styled.td`
  ${tableCellStyles}
  ${({ isLink }) => isLink && `
    &:hover {
      cursor: pointer;
      text-decoration: underline;
      color: ${colors.MAIN_COLOR};
    }
  `}
  ${({ width }) => width && `
  min-width: ${width};
  `}

  ${({ isIcon }) => isIcon && `
    text-align: right;
    min-width: inherit;
  `}

  ${({ isActive }) => typeof (isActive) === "boolean" && `
    span {
      margin-right: 18px;
      display: block;
      height: 12px;
      width: 12px;
      border-radius: 50%;
      background-color: #${isActive ? '0CFF00' : 'E7EBEC'};
    }
  `}

  > a > svg {
    fill: ${colors.LIGHT_GRAY};
  }
`;



export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  align-items: center;
  margin-top: 30px;
  .first-btn, .last-btn {
    color: ${colors.MAIN_COLOR};

    &.disabled {
      color: ${colors.LIGHT_GRAY};
    }

    &:hover {
      cursor: pointer;
    }
  }

  .prev {
    transform: rotate(90deg);
  }
  .next {
    transform: rotate(-90deg);
  }

  .prev, .next {
    margin: 0 30px 0 10px;
    svg {
      > g {
        fill: ${colors.MAIN_COLOR};
      }
    }
    

    &.disabled {
      svg {
        > g {
          fill: ${colors.LIGHT_GRAY};
        }
      }
    }
    &:hover {
      cursor: pointer;
    }
  }

  .page-btn {
    width: 36px;
    height: 36px;
    line-height: 36px;
    color: ${colors.MAIN_COLOR};

    &.selected {
      color: ${colors.DARK};
      border: 1px solid ${colors.LIGHT_GRAY};
    }

    &:hover {
      cursor: pointer;
      border: 1px solid ${colors.MAIN_COLOR};
    }
  }

`;



// WEBPACK FOOTER //
// ./src/components/Table/styledComponents.js